import * as React from "react";
import * as TooltipPrimitive from "@radix-ui/react-tooltip";

import { cn } from "../../lib/utils";

/**
 * Tooltip Provider bileşeni - Tooltip'lerin gösterilme davranışını kontrol eder
 * @returns {JSX.Element} Tooltip Provider bileşeni
 */
const TooltipProvider = TooltipPrimitive.Provider;

/**
 * Tooltip bileşeni - Tooltip'in kendisini temsil eder
 * @returns {JSX.Element} Tooltip bileşeni
 */
const Tooltip = TooltipPrimitive.Root;

/**
 * Tooltip Trigger bileşeni - Tooltip'i tetikleyen elementi sarar
 * @returns {JSX.Element} Tooltip Trigger bileşeni
 */
const TooltipTrigger = TooltipPrimitive.Trigger;

/**
 * Tooltip Content bileşeni - Tooltip içeriğini gösterir
 * @param {Object} props - Bileşen özellikleri
 * @returns {JSX.Element} Tooltip Content bileşeni
 */
const TooltipContent = React.forwardRef(({ className, sideOffset = 4, ...props }, ref) => (
  <TooltipPrimitive.Content
    ref={ref}
    sideOffset={sideOffset}
    className={cn(
      "z-50 overflow-hidden rounded-md border bg-popover px-3 py-1.5 text-sm text-popover-foreground shadow-md animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
      className
    )}
    {...props}
  />
));
TooltipContent.displayName = TooltipPrimitive.Content.displayName;

export { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider }; 